import React from 'react'
import {Navigate , useLocation} from 'react-router-dom'
const ProtectedRoute = ({children}) => {
    const location = useLocation()

    const hasAccess = location.state?.key
  return hasAccess ? children :<Navigate to="/"/>
      
   
  
}

export default ProtectedRoute
